module.exports = __webpack_public_path__ + "1-27.png?e8f8fbfa3777599c73173740444634e4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-27.png
// module id = 104
// module chunks = 0